import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import '@/App.css';
import { Toaster } from 'sonner';

// Pages
import HomePage from './pages/HomePage';
import PredictionPage from './pages/PredictionPage';
import OrbitSimulationPage from './pages/OrbitSimulationPage';
import BlockchainPage from './pages/BlockchainPage';
import HistoryPage from './pages/HistoryPage';
import Layout from './components/Layout';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/predict" element={<PredictionPage />} />
            <Route path="/orbit" element={<OrbitSimulationPage />} />
            <Route path="/blockchain" element={<BlockchainPage />} />
            <Route path="/history" element={<HistoryPage />} />
          </Routes>
        </Layout>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
